/// <reference path="../jsrender/jsrender.d.ts" />
/// <reference path="basket.d.ts" />
/// <reference path="lite_event.ts" />
/// <reference path="basket_notificator.ts" />
/// <reference path="../magscriber.d.ts" />

class BasketEvents implements IBasketEvents
{
    onLoadingStart: { (data?: boolean): void };
    onDataReceived: { (data?: boolean): void };
}

class Basket
{
    private static _instance : Basket = null;

    public static instance(events?: IBasketEvents)
    {
        if(Basket._instance == null)
        {
            Basket._instance = new Basket(events);
        }
        return Basket._instance;
    }
    
    private data:BasketAjaxResponse;

    private _onLoadingStart = new LiteEvent<boolean>();
    private _onDataReceived = new LiteEvent<boolean>();

    public get onLoadingStart(): ILiteEvent<boolean> { return this._onLoadingStart; }
    public get onDataReceived(): ILiteEvent<boolean> { return this._onDataReceived; }

    constructor(events?: IBasketEvents)
    {
        if(events != null)
        {
            if(events.onDataReceived != null)
            {
                this.onDataReceived.on(events.onDataReceived);
            }
            if(events.onLoadingStart != null)
            {
                this.onLoadingStart.on(events.onLoadingStart);
            }
        }

        let basket:Basket = this;

        basket._onLoadingStart.trigger(false);

        $.get(AjaxServices.basket.content, function (data) {
            basket.data = data;
            basket._onDataReceived.trigger(false);
        });
    }

    public get price():number {
        return this.data.price;
    }

    public get productsCount(): number {
        return this.data.amount;
    }

    public get items() : BasketAjaxResponseItems {
        return this.data.items;
    }

    public addItem(id: number, class_name:string, amount:number, parameters: { [key: string] : string}) : void
    {
        let basket:Basket = this;
        basket._onLoadingStart.trigger(true);

        parameters['product_id'] = id.toString();
        parameters['product_class'] = class_name;
        parameters['amount'] = amount.toString();

        $.get(
            AjaxServices.basket.items.add,
            parameters,
            function (data) {
                basket.data = data;
                basket._onDataReceived.trigger(true);
            }
        );
    }

    public changeItem(id: number, class_name : string, amount:number)
    {
        let basket:Basket = this;
        basket._onLoadingStart.trigger(true);
        $.get(
            AjaxServices.basket.items.change,
            {
                product_id: id,
                product_class: class_name,
                amount: amount
            },
            function (data) {
                basket.data = data;
                basket._onDataReceived.trigger(true);
            }
        );
    }

    public removeItem(id: number, class_name : string)
    {
        let basket:Basket = this;
        basket._onLoadingStart.trigger(true);
        $.get(
            AjaxServices.basket.items.remove,
            {
                product_id: id,
                product_class: class_name
            },
            function (data) {
                basket.data = data;
                basket._onDataReceived.trigger(true);
            }
        );
    }
}